(function () {
  const SELECTOR = '[data-discount-script="true"]';
  const ATTRIBUTE_NAMES = [
    'data-final-price',
    'data-final-price-formatted',
    'data-compare-price',
    'data-compare-price-formatted',
    'data-price-extras-html',
    'data-discount-savings-html',
    'data-savings-enabled',
    'data-savings-amount',
    'data-savings-formatted',
    'data-promo-badge-active',
    'data-promo-badge-image',
    'data-promo-badge-alt'
  ];

  let observer = null;
  let processingStarted = false;
  let startTimeout = null;

  function parsePrice(value) {
    if (typeof value !== 'string' || value.trim() === '') return NaN;
    const numeric = value.replace(/[^0-9.-]/g, '');
    return Number(numeric);
  }

  function getSavingsWrapper(element) {
    const next = element.nextElementSibling;
    if (next && next.classList && next.classList.contains('t4s-discount-savings-wrapper')) {
      return next;
    }
    return null;
  }

  function normalizeHtml(html) {
    if (typeof html !== 'string') return '';
    return html.replace(/\s+/g, ' ').trim();
  }

  function extractPromoBadgeConfig(element) {
    if (!element || !element.dataset) return null;
    if (element.dataset.promoBadgeActive !== 'true') return null;
    const image = element.dataset.promoBadgeImage;
    if (!image) return null;
    return {
      image,
      alt: element.dataset.promoBadgeAlt || ''
    };
  }

  function findListingBadgeTarget(element) {
    const product = element.closest?.('.t4s-product, .t4s-product-item, .t4s-product-wrapper');
    if (!product) return null;
    const imageContainer =
      product.querySelector('.t4s-product-img') ||
      product.querySelector('.t4s-product-image') ||
      product.querySelector('.t4s-product-inner .t4s_ratio') ||
      product.querySelector('.t4s-product-inner');
    return imageContainer || product;
  }

  function findPdpBadgeTarget() {
    return (
      document.querySelector('.t4s-product__media-wrapper .t4s-product__media .t4s-product-img') ||
      document.querySelector('.t4s-product__media-wrapper .t4s-product__media') ||
      document.querySelector('.t4s-product__media-wrapper') ||
      document.querySelector('.t4s-product__no_media') ||
      document.querySelector('.t4s-product__one_media')
    );
  }

  function ensurePromoBadge(target, config, context) {
    if (!target || !config) return;
    const className = 't4s-promo-image-badge';
    const contextClass = context === 'pdp' ? 't4s-promo-image-badge--pdp' : 't4s-promo-image-badge--listing';
    let badge = target.querySelector(`.${className}[data-context="${context}"]`);

    if (!badge) {
      badge = document.createElement('div');
      badge.className = `${className} ${contextClass}`;
      badge.dataset.context = context;
      const img = document.createElement('img');
      img.className = 't4s-promo-image-badge__image';
      badge.appendChild(img);

      if (typeof window !== 'undefined') {
        const computedStyle = window.getComputedStyle(target);
        if (computedStyle.position === 'static') {
          target.style.position = 'relative';
        }
      }

      target.appendChild(badge);
    }

    const img = badge.querySelector('img');
    if (img) {
      if (img.getAttribute('src') !== config.image) {
        img.setAttribute('src', config.image);
      }
      img.setAttribute('alt', config.alt);
    }
  }

  function ensurePromoBadgeInContainer(container, config) {
    if (!container) return false;
    if (container.getAttribute('data-promo-badge-container') !== 'true') {
      container.setAttribute('data-promo-badge-container', 'true');
      if (typeof window !== 'undefined') {
        const styles = window.getComputedStyle(container);
        if (styles.position === 'static') {
          container.style.position = 'relative';
        }
      }
    }
    const className = 't4s-promo-image-badge';
    let badge = container.querySelector(`.${className}`);

    if (config) {
      if (!badge) {
        badge = document.createElement('div');
        badge.className = `${className} t4s-promo-image-badge--container`;
        const img = document.createElement('img');
        img.className = 't4s-promo-image-badge__image';
        badge.appendChild(img);
        container.appendChild(badge);
      }

      const img = badge.querySelector('img');
      if (img) {
        if (img.getAttribute('src') !== config.image) {
          img.setAttribute('src', config.image);
        }
        img.setAttribute('alt', config.alt);
      }
      return true;
    }

    if (badge) {
      badge.remove();
      return true;
    }

    return false;
  }

  function ensureListingPromoSlot(product) {
    if (!product) return null;
    let slot = product.querySelector('.t4s-product-badge--promo-slot');
    if (slot) return slot;

    const baseBadge = product.querySelector('[data-product-badge]');
    if (baseBadge && baseBadge.parentElement) {
      slot = document.createElement('div');
      slot.className = 't4s-product-badge t4s-product-badge--promo-slot';
      slot.setAttribute('data-promo-badge-wrapper', 'true');
      baseBadge.insertAdjacentElement('afterend', slot);
      return slot;
    }

    const productInner = product.querySelector('.t4s-product-inner, .t4s-pr');
    if (productInner) {
      const host = productInner.querySelector('.t4s-product-badge--promo-host');
      if (host) return host;

      if (typeof window !== 'undefined') {
        const computedStyle = window.getComputedStyle(productInner);
        if (computedStyle.position === 'static') {
          productInner.style.position = 'relative';
        }
      }

      const newHost = document.createElement('div');
      newHost.className = 't4s-product-badge t4s-product-badge--promo-host';
      newHost.setAttribute('data-promo-badge-wrapper', 'true');
      productInner.appendChild(newHost);
      return newHost;
    }

    return null;
  }

  function ensureSinglePromoSlot() {
    let slot = document.querySelector('.t4s-product-single-badge--promo-slot');
    if (slot) return slot;

    let baseBadge = document.querySelector('[data-product-single-badge]');
    if (baseBadge && baseBadge.parentElement) {
      slot = document.createElement('div');
      slot.className = 't4s-single-product-badge t4s-product-single-badge--promo-slot';
      slot.setAttribute('data-promo-badge-wrapper', 'true');
      baseBadge.insertAdjacentElement('afterend', slot);
      return slot;
    }

    const mediaWrapper = document.querySelector('.t4s-product__media-wrapper');
    if (mediaWrapper) {
      const fallback = mediaWrapper.querySelector('.t4s-promo-single-badge-host');
      if (fallback) return fallback;

      if (typeof window !== 'undefined') {
        const mediaStyle = window.getComputedStyle(mediaWrapper);
        if (mediaStyle.position === 'static') {
          mediaWrapper.style.position = 'relative';
        }
      }

      const newHost = document.createElement('div');
      newHost.className = 't4s-single-product-badge t4s-promo-single-badge-host';
      newHost.setAttribute('data-promo-badge-wrapper', 'true');
      mediaWrapper.appendChild(newHost);
      return newHost;
    }

    return null;
  }

  function removePromoBadge(target, context) {
    if (!target) return;
    const selector = context ? `.t4s-promo-image-badge[data-context="${context}"]` : '.t4s-promo-image-badge';
    const badge = target.querySelector(selector);
    if (badge) {
      badge.remove();
    }
  }

  function updatePromoBadge(element) {
    const listingTarget = findListingBadgeTarget(element);
    const listingConfig = extractPromoBadgeConfig(element);

    if (listingTarget) {
      const product = element.closest?.('.t4s-product, .t4s-product-item, .t4s-product-wrapper');
      let container = product?.querySelector('[data-product-badge]');
      if (!container && listingConfig && product) {
        container = ensureListingPromoSlot(product);
      } else if (container && listingConfig) {
        const siblingSlot = ensureListingPromoSlot(product);
        if (siblingSlot) {
          container = siblingSlot;
        }
      }
      const containerHandled = ensurePromoBadgeInContainer(container, listingConfig);

      if (!containerHandled) {
        if (listingConfig) {
          ensurePromoBadge(listingTarget, listingConfig, 'listing');
        } else {
          const activeElement = product?.querySelector('[data-discount-script="true"][data-promo-badge-active="true"]');
          const activeConfig = activeElement ? extractPromoBadgeConfig(activeElement) : null;
          if (activeConfig) {
            ensurePromoBadge(listingTarget, activeConfig, 'listing');
          } else {
            removePromoBadge(listingTarget, 'listing');
          }
        }
      }
    }

    const isPdpContext = element.closest?.('.t4s-product__info-wrapper');
    if (isPdpContext) {
      const pdpTarget = findPdpBadgeTarget();
      if (!pdpTarget) return;
      const activeElement = document.querySelector('.t4s-product__info-wrapper [data-discount-script="true"][data-promo-badge-active="true"]');
      const pdpConfig = listingConfig || (activeElement ? extractPromoBadgeConfig(activeElement) : null);
      if (pdpConfig) {
        let singleBadgeContainer = ensureSinglePromoSlot();
        const containerHandled = ensurePromoBadgeInContainer(singleBadgeContainer, pdpConfig);
        if (!containerHandled) {
          ensurePromoBadge(pdpTarget, pdpConfig, 'pdp');
        }
      } else {
        const singleBadgeContainer =
          document.querySelector('[data-product-single-badge]') ||
          document.querySelector('.t4s-promo-single-badge-host');
        const containerHandled = ensurePromoBadgeInContainer(singleBadgeContainer, null);
        if (!containerHandled) {
          removePromoBadge(pdpTarget, 'pdp');
        }
      }
    }
  }

  function syncPromoBadges(root) {
    const scope = root || document;
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll(SELECTOR).forEach((element) => {
      if (!element || !element.dataset) return;
      updatePromoBadge(element);
    });
  }

  function applyToElement(element) {
    if (!processingStarted || !element || element.nodeType !== Node.ELEMENT_NODE) return;

    // Si tiene descuento por etiqueta, preservar el badge y solo actualizar el precio si es necesario
    const hasTagDiscount = element.dataset && element.dataset.tagDiscount === 'true';
    
    if (hasTagDiscount) {
      // Para productos con descuento por etiqueta, mostrar precio tachado y badge
      const finalPriceFormatted = element.dataset.finalPriceFormatted || '';
      const comparePriceFormatted = element.dataset.comparePriceFormatted || '';
      const extrasHtml = element.dataset.priceExtrasHtml || '';
      const finalPrice = parsePrice(element.dataset.finalPrice || '');
      const comparePrice = parsePrice(element.dataset.comparePrice || '');
      
      // Verificar si se debe mostrar el precio tachado
      const compareDisabled = element.dataset.compareDisabled === 'true';
      const hasComparePrice = !Number.isNaN(comparePrice) && comparePrice > 0;
      const hasCompare = !Number.isNaN(comparePrice) && !Number.isNaN(finalPrice) && comparePrice > finalPrice;
      
      // Para descuentos por etiqueta, siempre mostrar precio tachado si hay compare_at_price configurado
      const shouldShowCompare = !compareDisabled && comparePriceFormatted && hasComparePrice && (hasCompare || comparePrice >= finalPrice);

      let priceHtml = '';
      
      // Mostrar precio tachado si aplica
      if (shouldShowCompare) {
        priceHtml = `<del>${comparePriceFormatted}</del> <ins>${finalPriceFormatted}</ins>`;
      } else {
        priceHtml = finalPriceFormatted;
      }
      
      // Agregar el badge de etiqueta desde data-price-extras-html
      if (extrasHtml) {
        priceHtml += extrasHtml;
      }

      if (normalizeHtml(element.innerHTML) !== normalizeHtml(priceHtml)) {
        element.innerHTML = priceHtml;
      }
      
      // No actualizar el badge de promoción para productos con descuento por etiqueta
      return;
    }

    const finalPriceFormatted = element.dataset.finalPriceFormatted || '';
    const comparePriceFormatted = element.dataset.comparePriceFormatted || '';
    const extrasHtml = element.dataset.priceExtrasHtml || '';
    const savingsEnabled = element.dataset.savingsEnabled === 'true';
    const savingsHtml = element.dataset.discountSavingsHtml || '';
    const savingsFormatted = element.dataset.savingsFormatted || '';

    const finalPrice = parsePrice(element.dataset.finalPrice || '');
    const comparePrice = parsePrice(element.dataset.comparePrice || '');

    const hasCompare = !Number.isNaN(comparePrice) && !Number.isNaN(finalPrice) && comparePrice > finalPrice;

    let priceHtml = finalPriceFormatted;
    if (hasCompare && comparePriceFormatted) {
      priceHtml = `<del>${comparePriceFormatted}</del> <ins>${finalPriceFormatted}</ins>`;
    }
    if (extrasHtml) {
      priceHtml += extrasHtml;
    }

    if (normalizeHtml(element.innerHTML) !== normalizeHtml(priceHtml)) {
      element.innerHTML = priceHtml;
    }

    const wrapper = getSavingsWrapper(element);
    if (!wrapper) {
      return;
    }

    if (savingsEnabled && (savingsHtml || savingsFormatted)) {
      let wrapperHtml = savingsHtml;
      if (!wrapperHtml && savingsFormatted) {
        wrapperHtml = `<span class="t4s-discount-savings">Ahorra ${savingsFormatted}</span>`;
      }
      if (normalizeHtml(wrapper.innerHTML) !== normalizeHtml(wrapperHtml)) {
        wrapper.innerHTML = wrapperHtml;
      }
      wrapper.style.display = '';
    } else {
      if (wrapper.innerHTML.trim() !== '') {
        wrapper.innerHTML = '';
      }
      wrapper.style.display = 'none';
    }

    updatePromoBadge(element);
  }

  function applyAll(root) {
    if (!processingStarted) return;
    const scope = root || document;
    scope.querySelectorAll(SELECTOR).forEach(applyToElement);
  }

  function handleMutations(mutations) {
    if (!processingStarted) return;

    const elements = new Set();
    const badgeContainers = new Set();

    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.matches && node.matches(SELECTOR)) {
            elements.add(node);
          }
          node.querySelectorAll?.(SELECTOR).forEach((el) => elements.add(el));
        });
        const target = mutation.target;
        if (target instanceof Element) {
          if (target.matches('[data-product-badge], [data-product-single-badge]')) {
            badgeContainers.add(target);
          } else {
            target.querySelectorAll?.('[data-product-badge], [data-product-single-badge]').forEach((el) =>
              badgeContainers.add(el)
            );
          }
        }
      } else if (
        mutation.type === 'attributes' &&
        mutation.target &&
        mutation.target.matches &&
        mutation.target.matches(SELECTOR)
      ) {
        elements.add(mutation.target);
      } else if (
        mutation.type === 'attributes' &&
        mutation.target instanceof Element &&
        (mutation.target.matches('[data-product-badge], [data-product-single-badge]') ||
          mutation.target.closest?.('[data-product-badge], [data-product-single-badge]'))
      ) {
        const container = mutation.target.matches('[data-product-badge], [data-product-single-badge]')
          ? mutation.target
          : mutation.target.closest('[data-product-badge], [data-product-single-badge]');
        if (container) badgeContainers.add(container);
      }
    });

    if (elements.size === 0 && badgeContainers.size === 0) return;

    requestAnimationFrame(() => {
      elements.forEach((el) => applyToElement(el));
      badgeContainers.forEach((container) => {
        const product = container.closest('.t4s-product, .t4s-product-item, .t4s-product-wrapper') || document;
        const priceElement = product.querySelector('[data-discount-script="true"]');
        if (priceElement) {
          applyToElement(priceElement);
        }
      });
    });
  }

  function setupObserver() {
    if (observer || !processingStarted) return;
    observer = new MutationObserver((mutations) => {
      handleMutations(mutations);
      syncPromoBadges(document);
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ATTRIBUTE_NAMES
    });
  }

  function setupEventListeners() {
    const events = [
      'variant:changed',
      'variant:priceChange',
      'product:variant-change',
      'product:price:update',
      'cart:refresh'
    ];
    events.forEach((eventName) => {
      document.addEventListener(eventName, (event) => {
        if (!processingStarted) return;
        const target = event?.detail?.container || event?.target || document;
        requestAnimationFrame(() => applyAll(target instanceof Element ? target : document));
        requestAnimationFrame(() => syncPromoBadges(target instanceof Element ? target : document));
      });
    });

    document.addEventListener('shopify:section:load', (event) => {
      if (!processingStarted) return;
      const target = event?.target || document;
      requestAnimationFrame(() => applyAll(target instanceof Element ? target : document));
      requestAnimationFrame(() => syncPromoBadges(target instanceof Element ? target : document));
    });

    document.addEventListener('shopify:section:reorder', () => {
      if (!processingStarted) return;
      requestAnimationFrame(() => {
        applyAll(document);
        syncPromoBadges(document);
      });
    });
  }

  function startPromoBadgeHeartbeat() {
    let runs = 0;
    const maxRuns = 15;
    const interval = setInterval(() => {
      if (!processingStarted) return;
      syncPromoBadges(document);
      runs += 1;
      if (runs >= maxRuns) {
        clearInterval(interval);
      }
    }, 1500);
  }

  function startProcessing() {
    if (processingStarted) return;
    processingStarted = true;
    applyAll(document);
    syncPromoBadges(document);
    startPromoBadgeHeartbeat();
    setupObserver();
    setupEventListeners();
  }

  function init() {
    if (startTimeout) {
      clearTimeout(startTimeout);
    }
    startTimeout = setTimeout(startProcessing, 900);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

